/**
 checkBidsItem Проверка на заполненьсть всех полей заявки
 @param {Object} bid Обьект заявки
 *  @return {Boolean}
 **/
function checkBidsItem(bid) {
    return (
        Boolean(bid.date) &&
        Boolean(bid.time) &&
        Boolean(bid.servicesIDs.length) &&
        Boolean(Object.values(bid.employee).length)
    );
}

export { checkBidsItem };
export default checkBidsItem;
